/*******************************************************************************
ADD ALL jQUERY PLUGINS
Load all the jQuery plugins.
*******************************************************************************/

import doIfExists from './do-if-exists';
import doIfNotExists from './do-if-not-exists';
import flexFadeIn from './flex-fade-in';
import flexFadeOut from './flex-fade-out';
import safeHTML from './safe-html';

export default function addAlljQueryPlugins() {
    doIfExists();
    doIfNotExists();
    flexFadeIn();
    flexFadeOut();
    safeHTML();
}
